import React, { useMemo } from 'react';
import classnames from 'classnames';

const Icon = ({
	icon,
	size,
	space,
	regular,
	extended,
	className,
	onClick
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'material-icons',
		'icon',
		!regular && 'material-icons-outlined',
		extended && 'material-icons-extended',
		!size && 'icon--md',
		size && `icon--${size}`,
		space && 'icon--space',
		className
	), [regular, extended, size, space, className]);

	return <i translate="no" className={cls} onClick={onClick}>{icon}</i>;
};

export default Icon;
